export const BRAND_IDENTITY_FISHERMAN = 'FISH'
export const BRAND_IDENTITY_GLAMMATIC = 'GLAM'

export const WEBSITE_STACK_STATUS_LIVE = 'Live'
export const WEBSITE_STACK_STATUS_PREVIEW = 'Preview'
